var $bf90a11a7a42a0f7$exports = {};
$bf90a11a7a42a0f7$exports = {
    "colorPicker": `Color picker`,
    "twoDimensionalSlider": `2D slider`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorSwatch": `color swatch`,
    "transparent": `transparent`
};


export {$bf90a11a7a42a0f7$exports as default};
//# sourceMappingURL=en-US.module.js.map
